import styles from "./index.module.scss";
import { tip_png } from "@/assets/images";

type TipProps = {
  style?: object;
  text: any;
}

const Tip = (props: TipProps) => {
  const {
    style = {},
    text,
  } = props;

  return (
    <div
      style={style}
      className={styles["tip"]}
    >
      <img 
        src={tip_png}
        alt="" 
      />

      <span>{text}</span>
    </div>
  )
}

export default Tip;